module.exports = __webpack_public_path__ + "img/43.06b536f1.png";